import React from 'react';
import { CreativeListModelProps } from './CreativeListModel';
import i18n from 'i18n';
import styles from './CreativeList.module.scss';
import { isArchivedCampaignCreative } from 'core/creative/Creative';
import classNames from 'classnames/bind';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { Redirect } from 'react-router-dom';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import {
  addOnEnabled,
  hasFuncs,
  isPmax3Order,
  notArchivedChannel
} from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import { TablePlaceholder } from 'components/TablePlaceholder/TablePlaceholder';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import { PermissionItem } from 'core';
import { ADDONFEATURE } from 'core/agency/AddonFeature';

export class CreativeList extends React.Component<CreativeListModelProps> {
  handler: number;
  cssClassNames: any;
  campaignWritePermission: PermissionItem;

  constructor(props) {
    super(props);
    this.cssClassNames = classNames.bind(styles);
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
    const l1Object = this.props.model.l1Object;
    const channelAddonFeature = l1Object
      ? ADDONFEATURE.CHANNEL[l1Object.channel]
      : undefined;
    // ECOPD-5566：停用渠道底下的素材轉唯讀 —— 綁定 / 解綁 / 啟用等寫入操作全部收掉
    this.campaignWritePermission = (
      channelAddonFeature
        ? hasFuncs(Permission.CAMPAIGN_WRITE)
            .and(addOnEnabled(channelAddonFeature))
            .and(isPmax3Order(l1Object.adsOrderId))
        : hasFuncs(Permission.CAMPAIGN_WRITE).and(
            isPmax3Order(l1Object.adsOrderId)
          )
    ).and(notArchivedChannel(l1Object.channelGroupId));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
    }
  }

  componentWillUnmount() {
    this.props.model.event.remove(this.handler);
  }

  renderListNoDataIndication = () => {
    const renderSystemAdminPlaceholder = () => (
      <TablePlaceholder
        placeholder={i18n.t(
          'campaignCreativeList.labels.noDataWithoutAddPermission'
        )}
      />
    );
    return (
      <PermissionChecker
        permissionAware={this.campaignWritePermission}
        renderOtherwise={renderSystemAdminPlaceholder}
      >
        <TablePlaceholder
          placeholder={i18n.t('campaignCreativeList.labels.noData')}
        />
      </PermissionChecker>
    );
  };

  render() {
    const model = this.props.model;
    const rowClasses = (creative, rowIndex) => {
      let classes: any = null;
      if (rowIndex === 0) {
        classes = styles.summaryRow;
      } else if (isArchivedCampaignCreative(creative)) {
        classes = styles.archivedRow;
      }

      if (
        creative.stateColumn &&
        creative.stateColumn.styleName === 'budgetRemain'
      ) {
        classes = [classes, styles.lightDanger].join(' ');
      }

      return classes;
    };

    if (model.state.redirectPath) {
      return <Redirect push to={model.state.redirectPath} />;
    }
    return (
      <div className={styles.creativeList}>
        {model.state.loading && <LoadingIndicator />}
        <div className={styles.tableContainer}>
          <StickableTanstackTable
            hover
            keyField='id'
            stickFirstColumn
            stickLastColumn
            data={model.creativeList}
            columns={model.columns}
            hidePagination={true}
            noDataIndication={this.renderListNoDataIndication}
            rowClasses={rowClasses}
            summaryData={
              model.creativeList ? model.getSummaryData() : undefined
            }
          />
        </div>
      </div>
    );
  }
}
